/*
 * @Author: Alex
 * @Date: 2023-05-10 15:05:44
 * @Description: 地图标题 control
 */
import { Color, asString } from 'ol/color'
import RenderEvent from 'ol/render/Event'
import { Style } from 'ol/style'

import { CanvasControlBase } from './canvasControlBase'
import { ElementHelper } from '../mapUtil'

export default class CanvasTitleControl extends CanvasControlBase {
  //
  private myElement: HTMLDivElement

  constructor(options: {
    title?: string
    visible?: boolean
    style?: Style
    className?: string
  }) {
    const ele = ElementHelper.create('DIV', {
      className:
        (options.className || '') + ' ol-control-title ol-unselectable',
      style: {
        // FIXME: 这里设置不生效
        // display: 'block',
        // visibility: 'hidden'
      }
    }) as HTMLDivElement

    super({
      style: options.style,
      element: ele
    })

    this.myElement = ele

    this.setTitle(options.title || '')
    this.setVisible(options.visible !== false)
    this.myElement.style.font = this.getTextFont()
    this.myElement.style.visibility = 'hidden'
  }

  /**
   * Change the control style
   * @param {Style} style
   */
  setStyle(style: Style) {
    super.setStyle(style)
    // Element style
    if (this.myElement) {
      this.myElement.style.font = this.getTextFont()
    }
    // refresh
    if (this.getMap()) this.getMap()?.render()
  }

  /**
   * Set the map title
   * @param {string} map title.
   * @api stable
   */
  setTitle(title: string) {
    this.myElement.textContent = title
    this.set('title', title)
    if (this.getMap()) {
      try {
        this.getMap()?.renderSync()
      } catch (e) {
        /* ok */
      }
    }
  }

  /**
   * Get the map title
   * @param {string} map title.
   * @api stable
   */
  getTitle() {
    return this.get('title')
  }

  /**
   * Set control visibility
   * @param {bool} b
   * @api stable
   */
  setVisible(b: boolean) {
    this.myElement.style.display = b ? 'block' : 'none'
    if (this.getMap()) {
      try {
        this.getMap()?.renderSync()
      } catch (e) {
        /* ok */
      }
    }
  }
  /**
   * Get control visibility
   * @return {bool}
   * @api stable
   */
  getVisible() {
    return this.myElement.style.display !== 'none'
  }

  /**
   * canvas 绘制 标题
   * @param e event
   * @returns
   */
  protected draw(e: RenderEvent) {
    if (!this.getVisible()) return
    const ctx = this.getContext(e)
    if (!ctx) return

    // Retina device
    const ratio = e.frameState?.pixelRatio
    ctx.save()
    ctx.scale(ratio ?? 1, ratio ?? 1)
    // Position
    const eltRect = this.myElement.getBoundingClientRect()
    const mapRect = this.getMap()?.getViewport().getBoundingClientRect()
    const size = this.getMap()?.getSize()
    if (!size) return
    if (!mapRect) return
    const sc = size[0] / mapRect.width
    ctx.translate(
      Math.round((eltRect.left - mapRect.left) * sc),
      Math.round((eltRect.top - mapRect.top) * sc)
    )

    const h = this.myElement.clientHeight
    const w = this.myElement.clientWidth
    const left = w / 2

    ctx.beginPath()
    ctx.fillStyle = asString(this.getFill()?.getColor() as Color)
    ctx.rect(0, 0, w, h)
    ctx.fill()
    ctx.closePath()

    ctx.beginPath()
    ctx.fillStyle = asString(this.getTextFill()?.getColor() as Color)
    ctx.strokeStyle = asString(this.getTextStroke()?.getColor() as Color)
    ctx.lineWidth = this.getTextStroke().getWidth() ?? 1
    ctx.textAlign = 'center'
    ctx.textBaseline = 'middle'
    ctx.font = this.getTextFont()
    ctx.lineJoin = 'round'
    if (ctx.lineWidth) ctx.strokeText(this.getTitle(), left, h / 2)
    ctx.fillText(this.getTitle(), left, h / 2)
    ctx.closePath()

    ctx.restore()
  }
}
